import { render, staticRenderFns } from "./FlashNewsListView.vue?vue&type=template&id=6fab4fb8&scoped=true&"
import script from "./FlashNewsListView.vue?vue&type=script&lang=ts&"
export * from "./FlashNewsListView.vue?vue&type=script&lang=ts&"
import style0 from "./FlashNewsListView.vue?vue&type=style&index=0&id=6fab4fb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fab4fb8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fab4fb8')) {
      api.createRecord('6fab4fb8', component.options)
    } else {
      api.reload('6fab4fb8', component.options)
    }
    module.hot.accept("./FlashNewsListView.vue?vue&type=template&id=6fab4fb8&scoped=true&", function () {
      api.rerender('6fab4fb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/views/admin/flashNews/FlashNewsListView.vue"
export default component.exports